export default __webpack_public_path__ + "static/media/microsoftsqlserver.7289c1b3.svg";